import getURLParam from '../helpers/getURLParam'

const EpiTracking = () => {
  let epiParam = null

  const self = {
    init() {
      self.setEpiParam()
      self.storeEpiParam()
      self.setNewHrefs()
      self.firstEntryCheck()
      self.setClickEvents()
    },
    getParam (key) {
      return self.getParamFromURL(key) || sessionStorage.getItem(key)
    },
    getParamFromURL (key) {
      if (!window.location.search) return
      return getURLParam(key)
    },
    setEpiParam () {
      epiParam =
        self.getParamFromURL('epi') ||
        self.getParamFromURL('utm_source') ||
        sessionStorage.getItem('epi')
    },
    storeEpiParam () {
      if (!epiParam) return
      sessionStorage.setItem('epi', epiParam)
    },
    setNewHrefs () {
      if (!epiParam) return
      const $$targets = document.querySelectorAll('a[href*="adtraction"]')
      $$targets.forEach($target => {
        let href = $target.getAttribute('href')
        href = epiParam ? `${href}&epi=${epiParam}` : href
        $target.setAttribute('href', href)
      })
    }, 
    firstEntryCheck() {
      if (!(document.cookie.match(/^(.*;)?\s*entry_page_url\s*=\s*[^;]+(.*)?$/))) { // Cookie do not exist
        var date = new Date();
        date.setTime(date.getTime()+(1*24*60*60*1000));
        document.cookie = "entry_page_url"+"="+window.location.href+"; expires="+date.toGMTString()+"; path=/";
      }
    },
    setClickEvents() {

    }
  }

  return self
}

export default EpiTracking
